export default __webpack_public_path__ + "static/media/header.54533862.png";